import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Cliente } from 'src/app/shared/classes/productvenda';
import { AgenteEmissor, ClienteDTO, ClienteDTOEmail } from 'src/app/shared/dto/clientedto';
import { ClienteService } from 'src/app/shared/services/cliente.service';
import { API_CONFIG } from 'src/config/api.config';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  @ViewChild('confirmarModal', { static: false }) confirmarModal;
  @Input() themeLogo: string = 'assets/images/icon/logo.png' // Default Logo

  constructor(private httpClient: HttpClient,
    private modalService: NgbModal) { }

  cliente: ClienteDTOEmail = new ClienteDTOEmail;

  ngOnInit(): void {

  }

  onSubmit() {
    this.modalService.open(this.confirmarModal, {
      size: 'md',
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      backdrop: 'static'
    });

    console.log(this.cliente)

    this.httpClient.post<any>(`${API_CONFIG.baseUrl}/cliente/solicitacaocadastro`, this.cliente).subscribe(data => {
      alert('Email enviado com sucesso. Aguarde que entraremos em contato')
      window.location.reload();
    },
      error => {
        alert('ERRO! Não foi possível enviar o email. Tente novamente ou entre em contato.')
      });
  }

  public removeItem(idUsuario: any) {
    this.cliente.usuarios.splice(idUsuario, 1);
    console.log(this.cliente)
    //delete this.productVenda.passageiros[idPassageiro];
  }

  inserirDadosPassageiro(idUsuario: any, event: any, variavel: string) {
    let val = event.target.value;

    if (variavel == "nome") this.cliente.usuarios[idUsuario].nome = val;
    if (variavel == "email") this.cliente.usuarios[idUsuario].email = val;
    if (variavel == "cpf") this.cliente.usuarios[idUsuario].cpf = val;
    if (variavel == "celular") this.cliente.usuarios[idUsuario].celular = val;
  }

  adicionarPassageiro() {
    this.cliente.usuarios.push(new AgenteEmissor);
  }
}
